import Image from 'next/image';
import Link from 'next/link';

const socials = [
  { name: 'instagram', href: 'https://www.instagram.com/gomoworld_/' },
  { name: 'youtube', href: 'https://www.youtube.com/@gomoworld' },
  { name: 'tiktok', href: 'https://www.tiktok.com/@gomoworld_' },
  { name: 'facebook', href: 'https://www.facebook.com/GoMoWorld/' },
];

export const FooterSocials = () => {
  return (
    <div className={'flex items-center gap-3'}>
      {socials.map(social => (
        <Link
          key={social.name}
          href={social.href}
          target={'_blank'}
          onClick={() => {
            window.dataLayer?.push({
              event: 'click_button',
              click_id: social.href,
              click_label: social.name,
            });
          }}
        >
          <Image
            src={`/static/icons/${social.name}.svg`}
            alt={social.name}
            width={35.5}
            height={35}
          />
        </Link>
      ))}
    </div>
  );
};
